import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AccountService } from '../../../services/account.service';
import { SCAMP_API } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { CommandResult } from '../../domain/commandResult';
import { Arquivo } from '../../domain/domain.model';


@Injectable()
export class RotinaService {

    constructor(
        private http: HttpClient,
        private account: AccountService
    ) { }

    post(data: any, arquivos: Arquivo[], files: File[]): Observable<CommandResult>  {
        //return this.http.post(`${SCAMP_API.accountApiV1}/rotina`, data, {headers : this.account.composeHeaders()});
        
        const formData = new FormData();

        formData.append('rotina', JSON.stringify(data));
        formData.append('arquivos', JSON.stringify(arquivos));
        //formData.append('files', JSON.stringify(arquivos));

        files.forEach(file => formData.append('files', file, file.name));

        return this.http.post<CommandResult>(`${SCAMP_API.accountApiV1}/rotinas`, formData,
            { headers: this.account.composeHeaders() });

        
    }

    getById(id: number): Observable<any> {
        return this.http.get<any>(`${SCAMP_API.accountApiV1}/rotina/${id}`, {headers : this.account.composeHeaders()});
    }

    getAllByRotinaId(rotinaid: number): Observable<Arquivo[]> {
        return this.http.get<Arquivo[]>(`${SCAMP_API.accountApiV1}/rotinas/${rotinaid}`, 
        {headers : this.account.composeHeaders()});
    }

    update(id: number, data: any) {
        return this.http.put(`${SCAMP_API.accountApiV1}/rotina/${id}`, data, {headers : this.account.composeHeaders()});
    }

    delete(id: number) {
        return this.http.delete(`${SCAMP_API.accountApiV1}/rotina/${id}`, {headers : this.account.composeHeaders()});
    }

    list(areaTecnicaId: number): Observable<any[]> {
        return this.http.get<any[]>(`${SCAMP_API.accountApiV1}/rotinas/${areaTecnicaId}`, {headers : this.account.composeHeaders()});
    }


    isUniqueCodigoRotina(codigo: string): Observable<boolean> {
       
        return this.http.post<boolean>(`${SCAMP_API.accountApiV1}/codigo-rotina-is-unique`, {codigo},
        {headers : this.account.composeHeaders()});
    }

    getRotinaEquipamento(data: any): Observable<any> {
        return this.http.post(`${SCAMP_API.accountApiV1}/rotinas-equipamentos`, data, {headers : this.account.composeHeaders()});
    }

    removeFile(id: number, arquivoNome: string): Observable<CommandResult> {
        
        return this.http.delete<CommandResult>(`${SCAMP_API.accountApiV1}/rotinas/arquivos/delete/${id}/${arquivoNome}`,
            { headers: this.account.composeHeaders() });
    }


}
